import React from 'react';
import styled from 'styled-components';
import {
  SkeletonPulse,
  SkeletonLine,
} from 'components/theme/Skeleton/Skeleton';

export const BookingConfirmationCardSkeleton = () => {
  return (
    <SkeletonWrapper>
      <ImageSkeleton>
        <SkeletonPulse />
      </ImageSkeleton>
      <TextSkeleton>
        <SkeletonLine style={{ width: '100%', height: '19px' }} />
        <SkeletonLine style={{ width: '60%', height: '17px' }} />
      </TextSkeleton>
    </SkeletonWrapper>
  );
};

const SkeletonWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  border: 1px solid var(--scheme-alpha-10);
  background-color: var(--scheme-surface-level-1);
  width: 100%;
  overflow: hidden;
`;

const ImageSkeleton = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 3 / 2;
  overflow: hidden;
  flex-shrink: 0;
`;

const TextSkeleton = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 20px 24px 20px 0;
  flex-shrink: 0;
`;
